import { type CommandBarAction } from '../store/schema/CommandBarAction';

// The default configuration for the command bar buttons
const _default_1: CommandBarAction[] = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 18, 19, 9, 10, 11, 12, 13, 14, 17, 15, 16,
];
export default _default_1;
